<template>
  <DialogWrapper
    width="30%"
    :title="$t(`${i18nPrefix}.label.updateMobilePhone`)"
    :show.sync="isShow"
    :closeOnClickModal="false"
    @save="onSubmit"
  >
    <UpdateMobile
      ref="updateMobile"
      :isShow="isShow"
      :phone="phone"
      :countryCode="countryCode"
      :jobId="jobId"
      :captchaIndex="captchaIndex"
      :isCandidate="isCandidate"
      :companyId="companyId"
      @success="updateMobileSuccess"
    ></UpdateMobile>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import UpdateMobile from './updateMobile.vue'

export default {
  components: {
    DialogWrapper,
    UpdateMobile
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    phone: {
      type: String
    },
    countryCode: {
      type: String
    },
    jobId: {
      default: null
    },
    captchaIndex: {
      type: Number,
      required: true
    },
    isCandidate: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate'
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  created () {

  },
  methods: {
    async onSubmit () {
      await this.$refs.updateMobile.onSubmit()
    },
    updateMobileSuccess (formData) {
      this.$emit('success', formData)
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
